/**
 * Badge de elegibilidad de una convocatoria — dice QUIÉN puede aplicar.
 * Pieza de honestidad del Radar internacional (V2-S6.1): la cooperación
 * internacional rara vez se aplica directo, así que lo marcamos explícito.
 */
interface EligibilityMeta {
  label: string;
  tooltip: string;
  className: string;
}

const ELIGIBILITY: Record<string, EligibilityMeta> = {
  direct: {
    label: "Aplicas directo",
    tooltip: "Tu municipio puede ser el aplicante directo de esta convocatoria.",
    className: "bg-cta-50 text-cta-700 ring-cta-600/20",
  },
  via_partner: {
    label: "Vía aliado",
    tooltip:
      "El aplicante suele ser una ONG u organización aliada; tu municipio participa como socio en el territorio.",
    className: "bg-amber-50 text-amber-700 ring-amber-600/20",
  },
  info_only: {
    label: "Informativo",
    tooltip: "Referencia de contexto. Tu municipio no aplica directo a esta línea.",
    className: "bg-slate-100 text-slate-600 ring-slate-500/20",
  },
};

export function EligibilityBadge({ eligibility }: { eligibility: string }) {
  const meta = ELIGIBILITY[eligibility];
  if (!meta) return null;
  return (
    <span
      data-testid="eligibility-badge"
      data-eligibility={eligibility}
      title={meta.tooltip}
      aria-label={`Elegibilidad: ${meta.label}. ${meta.tooltip}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide uppercase ring-1 ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
